import { ExcelExportRequestDto } from '@asset-metrix/portal-gateway-client-js';

import { getContentDispositionFileExtension } from '../../utils/contentDisposition';
import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../../utils/errors';
import { triggerDownloadWithAnchorTag } from '../../utils/triggerDownloadWithAnchorTag';
import { portalGatewayClient } from '../portalGatewayClient';

export const datatableExcelDownload = async ({
  fileName,
  widgetId,
  selection,
  readOnly,
  workflowStateSelection,
}: Partial<ExcelExportRequestDto> & {
  fileName?: string;
  widgetId: string;
}) => {
  const response = await portalGatewayClient.table.downloadTableExcelExport(
    widgetId,
    {
      selection: selection ?? {},
      readOnly,
      workflowStateSelection,
    }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error fetching excel file'),
      response.status
    );
  }

  const contentDisposition = response.headers.get('content-disposition');

  // Use file extension from content-disposition header, because automatic extension assignment only works if the target system knows the mime type of the blob and the file name does not contain anything that already looks like an extension
  const fileExtension = contentDisposition
    ? getContentDispositionFileExtension(contentDisposition)
    : null;

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  triggerDownloadWithAnchorTag(
    blobUrl,
    fileExtension ? `${fileName}.${fileExtension}` : fileName
  );
};
